import { getInitials } from "@/data/team";

export default function InitialAvatar({ name, size = 56, variant = "navy" }) {
  const initials = getInitials(name);
  const bg = variant === "gold" ? "#C5A059" : "#0A1128";
  const fg = variant === "gold" ? "#0A1128" : "#C5A059";
  const border = variant === "gold" ? "#0A1128" : "#C5A059";
  const style = {
    width: size,
    height: size,
    backgroundColor: bg,
    color: fg,
    borderColor: border,
    fontSize: Math.round(size * 0.38),
  };
  return (
    <div
      className="flex shrink-0 items-center justify-center rounded-full border-2 font-serif font-semibold tracking-wide"
      style={style}
      aria-hidden="true"
    >
      {initials}
    </div>
  );
}
